export function getView(selected) {
  return (
    Object.keys(selected).filter(item => selected[item] === true).length > 0
  )
}
